export enum CardActionsEnum {
	Delete = 'delete',
}
